<template>
  <div class="welcome-empty">
    <!--    <el-x-welcome-->
    <!--      variant="borderless"-->
    <!--      title="欢迎使用 Dify AI 助手"-->
    <!--      description="我是您的智能助手，可以帮助您完成各种任务，包括内容创作、代码编写、数据分析等。请告诉我您需要什么帮助！"-->
    <!--    >-->
    <!--      <template #image>-->
    <!--        <img-->
    <!--          :src="require('@/assets/images/dify-logo.svg')"-->
    <!--          alt="Dify"-->
    <!--        />-->
    <!--      </template>-->
    <!--    </el-x-welcome>-->
    <!--    <br v-if="!isMobile"/>-->
    <!--    <el-x-prompts-->
    <!--        v-if="!isMobile"-->
    <!--        :items="promptItems"-->
    <!--        :styles="promptStyles"-->
    <!--        :wrap="true"-->
    <!--        @on-item-click="handlePromptItemClick"-->
    <!--    >-->
    <!--      <template v-slot:icon="{ item }">-->
    <!--        <i-->
    <!--            :class="item.icon"-->
    <!--            :style="item.iconStyle"-->
    <!--        ></i>-->
    <!--      </template>-->
    <!--    </el-x-prompts>-->
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  computed: {
    isMobile() {
      return window.innerWidth <= 767;
    },
  },
  data() {
    return {
      promptItems: [
        {
          key: '1',
          label: 'AI 应用场景',
          icon: 'el-icon-magic-stick',
          iconStyle: {color: '#4d6bfe'},
          description: '探索 Dify 的强大功能',
          children: [
            {
              key: '1-1',
              icon: 'el-icon-cpu',
              iconStyle: {color: '#4d6bfe'},
              description: '如何使用 Dify 创建 AI 应用？',
            },
            {
              key: '1-2',
              icon: 'el-icon-monitor',
              iconStyle: {color: '#4d6bfe'},
              description: 'Dify 支持哪些大语言模型？',
            },
            {
              key: '1-3',
              icon: 'el-icon-user',
              iconStyle: {color: '#4d6bfe'},
              description: '如何自定义 AI 助手的角色？',
            },
          ],
        },
        {
          key: '2',
          label: '开发指南',
          icon: 'el-icon-code',
          iconStyle: {color: '#626aef'},
          description: '快速上手 Dify 开发',
          children: [
            {
              key: '2-1',
              icon: 'el-icon-document',
              iconStyle: {color: '#626aef'},
              description: 'Dify API 接口使用说明',
            },
            {
              key: '2-2',
              icon: 'el-icon-connection',
              iconStyle: {color: '#626aef'},
              description: '如何集成到现有应用',
            },
            {
              key: '2-3',
              icon: 'el-icon-data-analysis',
              iconStyle: {color: '#626aef'},
              description: '数据集管理最佳实践',
            },
          ],
        },
      ],
      promptStyles: {
        item: {
          flex: 'none',
          backgroundImage: 'linear-gradient(137deg, #f0f7ff 0%, #edf1ff 100%)',
          border: '0',
          width: 'calc(50% - 6px)',
        },
        subItem: {
          background: 'rgba(255,255,255,0.6)',
          border: '1px solid #e6efff',
        },
      },
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handlePromptItemClick({data}) {
      this.$emit('click-prompt', data);
    },
    handleResize() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome-empty {
  width: 100%;
  max-width: 100%;
  min-height: 80px;
  background-image: url("data:image/png;base64,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");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  margin: 0 16px;
  user-select: none;
}

// 移动端微调 (<768px)
@media screen and (max-width: 767px) {
  ::v-deep .el-x-prompts {
    padding: 0 20px;

    .el-x-prompts-list {
      gap: 8px;
    }

    .el-x-prompts-list-vertical {
      .el-x-prompts-item {
        width: 100% !important;
        // width: calc(100% - 8px) !important; // 移动端单列布局
        margin-bottom: 8px !important;
        padding: 14px 16px !important;

        .el-x-prompts-content {
          gap: 6px !important;
        }

        .el-x-prompts-label {
          font-size: 15px !important;
          line-height: 1.4 !important;
        }

        .el-x-prompts-desc {
          font-size: 13px !important;
          line-height: 1.3 !important;
        }
      }
    }
  }
  .welcome-empty {
    width: 315px;
    height: 52px;
  }
}
</style>
